import { colors } from "theme";

const buildVariantStyle = (
  backgroundColor: string,
  borderColor: string,
  textColor: string,
) => ({
  backgroundColor,
  border: `1px solid ${borderColor}`,
  borderRadius: 4,
  boxShadow: "none",
  color: textColor,
  fontFamily: "Inter, sans-serif",
  minWidth: 300,
  maxWidth: 700,
  "& #client-snackbar": {
    display: "flex",
    alignItems: "center",
    fontFamily: "Inter, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "20px",
    color: textColor,
  },
  "& .MuiSvgIcon-root": {
    color: textColor,
    fontSize: 18,
  },
  "& .MuiIconButton-root": {
    color: textColor,
    marginLeft: 8,
    padding: 4,
  },
  "& .MuiIconButton-root:hover": {
    backgroundColor: "transparent",
    opacity: 0.8,
  },
  "& a": {
    color: colors.accentPurple,
    textDecoration: "underline",
  },
});

export const appNotificationStyles = {
  variantSuccess: buildVariantStyle(
    colors.green[50],
    colors.green[500],
    colors.green[900],
  ),
  variantError: buildVariantStyle(
    colors.red[0],
    colors.red[500],
    colors.red[900],
  ),
  variantWarning: buildVariantStyle("#FFF5DC", "#FFBE14", "#6D3C09"),
  variantInfo: buildVariantStyle(
    colors.gray[50],
    colors.charcoal.soft,
    colors.gray[800],
  ),
};
